define(['text!./templates/mfp-show-vehicle.html'], (templateStr) => {

    directive.$inject = ['BaslerCommonService', 'LocaleService'];

    function directive(BaslerCommonService, LocaleService) {
        return {
            restrict: 'E',
            scope: {
                vehicle: '=',
            },
            template: templateStr,
            link: function (scope) {
                scope.formatDate = BaslerCommonService.formatDate;
                scope.getCollapsed = function () {
                    return scope.$parent.$parent.collapsed;
                };
                scope.appCurrency = LocaleService.getLocaleInfo().currency.symbol;
                scope.isParkingOvernightAvailable = () => scope.vehicle && scope.vehicle.parkingOvernight && scope.vehicle.parkingOvernight.value && scope.vehicle.parkingOvernight.value.name;
            },
        };
    }

    return directive;
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPShowVehicle.js